<div *ngIf="transactions">
  <h4 id="transactionCountHeaderLabel">
    {{ transactions?.length }} {{ 'ARC_PAYMENT_TRANSACTIONS' | translate }}
  </h4>
  <p-table
    #table
    aurCompactTable
    id="transactions-table"
    sortField="paymentAmount"
    paginatorDropdownAppendTo="body"
    [columns]="columns"
    [value]="transactions"
    [paginator]="true"
    [rows]="10"
    [scrollable]="true"
    [scrollHeight]="scrollHeight"
    [rowsPerPageOptions]="[10, 25, 50]"
  >
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th
          *ngFor="let column of columns"
          pFrozenColumn
          class="{{ column.field }}"
          [frozen]="column.frozen"
          [alignFrozen]="column.alignFrozen"
          [pSortableColumn]="column.sortable ? column.field : null"
          [hidden]="!column.visible"
          [ngClass]="{ currency: column.currency, unfrozen: !column.frozen }"
          [ngStyle]="column.width && { width: column.width }"
        >
          {{ column.header | translate }}
          <p-sortIcon
            *ngIf="column.sortable"
            [field]="column.field"
          ></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr>
        <td
          *ngFor="let column of columns"
          class="{{ column.field }}"
          pFrozenColumn
          [frozen]="column.frozen"
          [alignFrozen]="column.alignFrozen"
          [hidden]="!column.visible"
          [ngClass]="{
            wrap: column.wrap,
            currency: column.currency,
            unfrozen: !column.frozen
          }"
          [ngStyle]="column.width && { width: column.width }"
        >
          <ng-container [ngSwitch]="column.field">
            <ng-container *ngSwitchCase="'confirmationNumber'">
              {{ rowData.transactionReference ?? '' }}
            </ng-container>
            <ng-container *ngSwitchCase="'transactionNumber'">
              <div>{{ rowData.transactionNumber ?? '' }}</div>
            </ng-container>
            <ng-container *ngSwitchCase="'buyerAccount'">
              {{
                rowData.buyerAccountIdentifier?.replace('accountNumber:', '') ??
                  ''
              }}
            </ng-container>
            <ng-container *ngSwitchCase="'discountApplied'">
              {{ rowData.totalDiscount ?? 0 | currency }}
              <span id="currency" class="text-grey">
                {{ rowData.currencyCode }}</span
              >
            </ng-container>
            <ng-container *ngSwitchCase="'subtotalAmount'">
              {{ rowData.subtotal ?? 0 | currency }}
              <span id="currency" class="text-grey">
                {{ rowData.currencyCode }}</span
              >
            </ng-container>
            <ng-container *ngSwitchCase="'creditMemoAmount'">
              {{ rowData.totalCredit ?? 0 | currency }}
              <span id="currency" class="text-grey">
                {{ rowData.currencyCode }}</span
              >
            </ng-container>
            <ng-container *ngSwitchCase="'creditCardProcessingFee'">
              {{ rowData.totalSurcharge ?? 0 | currency }}
              <span id="currency" class="text-grey">
                {{ rowData.currencyCode }}</span
              >
            </ng-container>
            <ng-container *ngSwitchCase="'paymentAmount'">
              {{ rowData.totalAmount ?? 0 | currency }}
              <span id="currency" class="text-grey">
                {{ rowData.currencyCode }}</span
              >
            </ng-container>
            <ng-container *ngSwitchCase="'status'">
              <span
                [class]="{
                  'aur-badge': true,
                  success:
                    rowData.status === transactionStatus.CAPTURED ||
                    rowData.status === transactionStatus.SCHEDULED,
                  warning: rowData.status === transactionStatus.PENDING,
                  danger: rowData.status === transactionStatus.FAILED
                }"
                >{{ rowData.status | titlecase }}</span
              >
            </ng-container>
          </ng-container>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
